import { connect } from 'react-redux';

import { EFeedbackComplaint, statusChanger } from '../../store/complaint/feedback_complaint';
import { toggle } from '../../store/popups/print';
import { BottomControlPanel, IBottomControlPanelDispatchProps, IBottomControlPanelProps } from './index';

import type { DispatchReduxAction, IState } from '../../store';

function mapStateToProps(state: IState): IBottomControlPanelProps {
  return {
    agent: state.offerData.agent,
    docxUrl: state.offerData.offer.exportLinks.docxUrl,
    offer: state.offerData.offer,
    pdfUrl: state.offerData.offer.exportLinks.pdfUrl,
  };
}

function mapDispatchToProps(dispatch: DispatchReduxAction): IBottomControlPanelDispatchProps {
  return {
    openPrintModal: () => dispatch(toggle(true)),
    complaintFeedbackFormStatus: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BottomControlPanelContainer = connect<IBottomControlPanelProps, IBottomControlPanelDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(BottomControlPanel);
